import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  TerminalListQuery,
  TerminalRepository,
} from '@app/domain/ports/tpv/terminal.repository';
import { TpvTerminal } from '@app/domain/models/tpv/terminal.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';
import { TerminalDto } from '@app/data/dtos/tpv/terminal.dto';
import { mapTerminal } from '@app/data/mappers/tpv/terminal.mapper';
import { toTpvPage } from '@app/data/mappers/tpv/tpv-page.mapper';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope } from '@app/data/tpv/tpv-envelope';
import { toHttpParams } from './tpv-http.util';

/** `GET /api/v1/tpv/terminals/`. `id_merchant` obligatorio. Auth vía interceptores estándar. */
@Injectable()
export class TerminalRemoteDataSource extends TerminalRepository {
  private readonly http = inject(HttpClient);

  override getTerminals(
    externalIdMerchant: string,
    query: TerminalListQuery = {},
  ): Observable<TpvPage<TpvTerminal>> {
    const page = query.page ?? 1;
    const limit = query.limit ?? 10;
    const params = toHttpParams({
      id_merchant: externalIdMerchant,
      page,
      limit,
      merchant_name: query.merchantName,
    });

    return this.http
      .get<TpvEnvelope<unknown>>(tpvUrl('terminals/'), { params })
      .pipe(map((raw) => toTpvPage<TerminalDto, TpvTerminal>(raw, mapTerminal, { page, limit })));
  }
}
